import { CheckOutlined, DeleteOutlined, EditOutlined } from '@ant-design/icons';
import axiosClient from 'axios/axiosClient';
import { Toast } from 'helper/alert';
import { t } from 'i18next';
import React, { useState } from 'react';

export default function CalendarPlanRoleRow({ defaultRole, isUpdate, setIsUpdate }) {
  const [role, setRole] = useState(defaultRole);
  const [isEditing, setIsEditing] = useState(false);

  const handleOnChange = (e) => {
    setRole({ ...role, [e.target.name]: e.target.value });
  };
  const handleUpdate = (e) => {
    let isValid = true;
    for (const key of Object.keys(role)) {
      if (role[key]?.length == 0 && key !== 'description') {
        isValid = false;
      }
    }
    if (isValid) {
      axiosClient
        .post('calendar-plan/role/update', { role })
        .then((_) => {
          Toast.fire({ icon: 'success', title: `${t('update-role')} ${t('success')}` });
          setIsUpdate(!isUpdate);
          setIsEditing(false);
        })
        .catch((err) => {
          Toast.fire({ icon: 'error', title: `${t('update-role')} ${t('unsuccess')}` });
        });
    } else {
      Toast.fire({ icon: 'error', title: `${t('please-input-all')} ` });
    }
  };
  const handleDelete = (e) => {
    axiosClient
      .post('calendar-plan/role/delete', { role })
      .then((_) => {
        Toast.fire({ icon: 'success', title: `${t('delete-role')} ${t('success')}` });
        setIsUpdate(!isUpdate);
      })
      .catch((err) => {
        Toast.fire({ icon: 'error', title: `${t('delete-role')} ${t('unsuccess')}` });
      });
  };
  return (
    <tr className="calendar-plan-create-role__item">
      <td className="calendar-plan-create-role__item-label">
        <input
          name="role"
          disabled={!isEditing}
          type="text"
          value={role.role}
          onChange={handleOnChange}
          required
        />
      </td>
      <td className="calendar-plan-create-role__item-label">
        <input
          name="key"
          disabled={!isEditing}
          type="text"
          value={role.key}
          required
          onChange={handleOnChange}
        />
      </td>
      <td className="calendar-plan-create-role__item-description">
        <input
          name="rank"
          disabled={!isEditing}
          type="number"
          value={role.rank}
          onChange={handleOnChange}
          required
        />
      </td>
      <td className="calendar-plan-create-role__item-description">
        <input
          name="description"
          disabled={!isEditing}
          type="text"
          value={role.description || t('no-description')}
          onChange={handleOnChange}
        />
      </td>
      <td className="calendar-plan-create-role__item-action">
        {isEditing ? (
          <CheckOutlined onClick={handleUpdate} />
        ) : (
          <EditOutlined
            onClick={() => {
              setIsEditing(true);
            }}
          />
        )}

        {/* <DeleteOutlined onClick={handleDelete} /> */}
      </td>
    </tr>
  );
}
